import { connect } from 'react-redux';
import { getCurrentUserId } from '../publicSession/selectors';
const mapStateToProps = (state, { user  })=>({
        isOwnUser: user ? user.userId === getCurrentUserId(state) : false
    });
export default connect(mapStateToProps);
